
import Breadcrumbs from '~/components/UI/Breadcrumbs.vue';
import SetsMixin from '~/node_modules/sitis-nuxt/lib/mixins/SetsMixin';
import Filters from '~/components/filters/Filters.vue';
import FlatTypeCard from "~/components/apartments/FlatTypeCard.vue";

export default {

    components: {
        Breadcrumbs,
        Filters,
        FlatTypeCard,
        MessageImage: () => import('~/components/sets-page/MessageImage.vue'),
        ProductsTemplate: () => import('~/components/apartments/Products.vue'),
        ContentProducts: () => import('~/components/sets-page/ContentProducts.vue'),
        ContentProductsMobile: () => import('~/components/sets-page/ContentProductsMobile.vue'),
    },

    mixins: [
        SetsMixin,
    ],

    data() {
        return {
            tableOptions: [
                {
                    label: '№ кв стр',
                    fieldName: 'name',
                    sort: 'name',
                },
                {
                    label: 'Этаж',
                    charName: 'etaz',
                    sort: 'etaz',
                },
                {
                    label: 'Этажность',
                    charName: 'etaznost',
                    sort: 'etaznost',
                },
                {
                    label: 'Кол-во комнат',
                    charName: 'rooms',
                    sort: 'rooms',
                },
                {
                    label: 'Общая площадь',
                    charName: 'plosad',
                    sort: 'plosad',
                },
                {
                    label: 'Цена за кв.м.',
                    charName: 'cena-za-m',
                    type: 'number',
                    sort: 'cena-za-m',
                },
                {
                label: 'Статус',
                charName: 'status',
                sort: 'status',
              },
                {
                    label: 'Стоимость',
                    fieldName: 'price',
                    type: 'number',
                    sort: 'price',
                },
                {
                    label: '',
                    fieldName: 'imageId',
                    type: 'image',
                },
                // {
                //     label: '',
                //     align: 'right',
                //     fieldName: 'action',
                //     fieldLabel: 'Забронировать',
                // },
            ],
        };
    },
    head() {
        const title = this.category?.seo?.title || this.category?.metaTitle || this.category?.title || '';
        const head = {
            title,
            meta: [],
        };

        if (title) {
            head.meta.push({
                name: 'og:title', hid: 'og:title', property: 'og:title', content: title,
            });
        }

        const description = this.category?.seo?.description || this.category?.metaDescription || this.category?.description || '';
        if (description) {
            head.meta.push({ hid: 'metadescription', name: 'description', content: description });
            head.meta.push({
                name: 'og:description', hid: 'og:description', property: 'og:description', content: description,
            });
        }

        return head;
    },

  asyncData: async function({ $api }) {
      const filterPages = await $api.agent.transport.get('/filter-pages')
        .then(response => response.data || []).catch(() => []);
      console.log('filterPages: ', filterPages)

    const searchParams = [
        'per-page=1',
        'sort=price',
        'expand=short_characteristics'
      ].join('&')
      const flatStudia = await $api.agent.transport.get(`/filter-pages/studia/products?${ searchParams }`)
        .then((res) => {
          let _item = res.data?.[0] || null;
          if (!_item) return null
          return {
            ..._item,
            title: 'Квартира-студия',
            link: '/planirovki/studia',
            image_id: filterPages.find((t) => t.slug === 'studia')?.image_id || _item.image_id,
          }
        }).catch(() => {null});
      const flatOdnokomnatnaya = await $api.agent.transport.get(`/filter-pages/odnokomnatnaya-kvartira/products?${ searchParams }`)
        .then((res) => {
          let _item = res.data?.[0] || null;
          if (!_item) return null
          return {
            ..._item,
            title: '1-комнатная квартира',
            link: '/planirovki/odnokomnatnaya-kvartira',
            image_id: filterPages.find((t) => t.slug === 'odnokomnatnaya-kvartira')?.image_id || _item.image_id,
          }
        }).catch(() => {null});
      const flatDvyhkomnatnie = await $api.agent.transport.get(`/filter-pages/dvyhkomnatnie-kvartiry/products?${ searchParams }`)
        .then((res) => {
          let _item = res.data?.[0] || null;
          if (!_item) return null
          return {
            ..._item,
            title: '2-комнатная квартира',
            link: '/planirovki/dvyhkomnatnie-kvartiry',
            image_id: filterPages.find((t) => t.slug === 'dvyhkomnatnie-kvartiry')?.image_id || _item.image_id,
          }
        }).catch(() => {null});
      const flatTrehkomnatnye = await $api.agent.transport.get(`/filter-pages/trehkomnatnye-kvartiry/products?${ searchParams }`)
        .then((res) => {
          let _item = res.data?.[0] || null;
          if (!_item) return null
          return {
            ..._item,
            title: '3-комнатная квартира',
            link: '/planirovki/trehkomnatnye-kvartiry',
            image_id: filterPages.find((t) => t.slug === 'trehkomnatnye-kvartiry')?.image_id || _item.image_id,
          }
        }).catch(() => {null});
      const flatKvartirySRemontom = await $api.agent.transport.get(`/filter-pages/kvartiry-s-remontom/products?${ searchParams }`)
        .then((res) => {
          let _item = res.data?.[0] || null;
          if (!_item) return null
          return {
            ..._item,
            title: 'Квартира с ремонтом',
            link: '/planirovki/kvartiry-s-remontom',
            image_id: filterPages.find((t) => t.slug === 'kvartiry-s-remontom')?.image_id || _item.image_id,
          }
        }).catch(() => {null});


      return {
        flatTypes: [
          flatStudia,
          flatOdnokomnatnaya,
          flatDvyhkomnatnie,
          flatTrehkomnatnye,
          flatKvartirySRemontom
        ].filter((t) => !!t)
      }
  },

  computed: {
        breadcrumbs() {
            return [
                { path: '/', title: 'Главная' },
                { path: this.$route.path, title: this.pageTitle },
            ];
        },
        pageTitle() {
            return this.category?.title || '';
        },
        labelCountFree() {
            const count = Number.parseFloat(this.total);
            const word = this.$caseWords(count, [
                'квартира', 'квартиры', 'квартир',
            ]);

            return [count, word].join(' ');
        },

        isLoadProducts() {
            const loadingState = this.$store.state.appState.loading || {};
            return Boolean(loadingState?.category || loadingState.products);
        },

        extensions() {
            return ['short_characteristics'];
        },
        defaultSort() {
            return 'name';
        },

        visualChoseCmsBlock() {
            return this.$store.state?.appState?.vars?.['ID страницы для блока визуального выбора'] || '';
        },
    },

    methods: {
        openCallBack(product) {
            const message = `Заявка на бронирование квартиры "${product.name}"`;
            const additional_data = {
                macro_id: parseInt((product?.code || '').match(/\d+/)),
            };

            this.$store.commit('back-call/setOpen', {
                open: true,
                settings: {
                    title: 'Бронирование квартиры',
                    formType: 'Бронирование квартиры',
                    message,
                    additional_data,
                    reachGoal: 'bronirovanie_kvartiry',
                },
            });
        },
        clickRow(product) {
            this.$router.push(product.url);
        },
        async onRequestUpdateFilter(filters) {
          clearTimeout(this.timeOutUpdateProducts);
          this.timeOutUpdateProducts = setTimeout(async () => {
            await this.getUpdateFilters(filters);
            await this.onRequestUpdateProducts(filters);
          }, 500);
        },
        async onRequestUpdateProducts (filters) {
          await this.updateFiltersQuery(filters)
          await this.searchProducts(filters)
        },
        handleClearFilters: function () {
          this.clearFilters();
        },
    },
};
